import { Component, OnInit } from '@angular/core';
import { FlowServiceService } from '../Services/flow-service.service';

@Component({
  selector: 'app-privacypolicy',
  templateUrl: './privacypolicy.component.html',
  styleUrls: ['./privacypolicy.component.scss']
})
export class PrivacypolicyComponent implements OnInit {
  sections = [
    { id: 'introduction', title: '1. Introduction' },
    { id: 'service', title: '2. The Service' },
    { id: 'data-collection', title: '3. Data Collection' },
    { id: 'user-obligations', title: '4. User Obligations' },
    { id: 'liability', title: '5. Liability' }
  ];

  constructor(private flowServiceService: FlowServiceService) {  
    window.scrollTo(0,0);
    window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    });
  }

  ngOnInit() {
    window.scrollTo(0,0)
    this.flowServiceService.setScrollTop();
  }
}
